<template>
  <NuxtLink v-if="nuxtLink" :to="nuxtLink" href="#" :disabled="disabled || invisible" :class="{ 'invisible': invisible }">
    <button
      data-cy="back"
      :disabled="disabled || invisible"
      type="button"
      class="btn btn-outline-back fade-ease-in-out"
      :class="{ 'opacity-0': invisible }"
      @click="$emit('submit')"
    >
      <fa-icon :icon="['fal', 'chevron-left']" class="pe-2"></fa-icon>
      Back
    </button>
  </NuxtLink>
  <button
    v-else
    data-cy="back"
    :disabled="disabled || invisible"
    type="button"
    class="btn btn-outline-back fade-ease-in-out"
    :class="{ 'opacity-0': invisible }"
    @click="$emit('submit')"
  >
    <fa-icon :icon="['fal', 'chevron-left']" class="pe-2"></fa-icon>
    Back
  </button>
</template>

<script>
export default {
  name: "MarketplaceBackButton",
  emits: ['submit'],
  props: {
    nuxtLink: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    invisible: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-ease-in-out {
  transition: opacity 0.2s ease-in-out !important;
}
</style>
